/* eslint-disable */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'index.js';
import * as moment from 'moment/moment';
import 'moment/locale/ja';
import { apiUrl } from 'App.js';
import {
  registerAmazon,
  registerRakuten
} from 'feactures/channel/channelSlice';

//先月
export const lastmonth = moment()
  .add(-1, 'month')
  .startOf('month')
  .format('YYYY-MM');

// 先々月
export const twoMonthsAgo = moment()
  .add(-2, 'month')
  .startOf('month')
  .format('YYYY-MM');

/** チャネル切替時に、そのチャネルで最後に選んだ月を復元する（API 不要） */
export const resolveYearMonthForChannel = (
  channel,
  {
    amazonList,
    rakutenList,
    amazonLast,
    rakutenLast,
    amazonSelectedMonth,
    rakutenSelectedMonth
  }
) => {
  if (channel !== 1 && channel !== 2) return null;
  const list = channel === 1 ? amazonList : rakutenList;
  const lastMonth = channel === 1 ? amazonLast : rakutenLast;
  const stored = channel === 1 ? amazonSelectedMonth : rakutenSelectedMonth;
  if (!Array.isArray(list) || list.length === 0) return null;
  if (stored && list.includes(stored)) return stored;
  if (lastMonth && list.includes(lastMonth)) return lastMonth;
  return list[0];
};

/** チャネル切替時: 保存済みの選択月（未設定なら各チャネルの最新月）で yearMonth を復元 */
const switchYearMonthOnChannelChange = (state, newChannel) => {
  const next = resolveYearMonthForChannel(newChannel, {
    amazonList: state.amazonMonthList,
    rakutenList: state.rakutenMonthList,
    amazonLast: state.amazonCurrentLastMonth,
    rakutenLast: state.rakutenCurrentLastMonth,
    amazonSelectedMonth: state.amazonSelectedMonth,
    rakutenSelectedMonth: state.rakutenSelectedMonth
  });

  if (next) {
    state.yearMonth = next;
  }
};

export const resetKubunYearMonth = createAsyncThunk(
  'checkMarketData/post',
  async (arg, thunkAPI) => {
    const { channel } = thunkAPI.getState().currentchannel;
    const res = await client.post(`${apiUrl}check_market_data`, {
      channel
    });
    return { ...res.data, requestChannel: channel };
  },
  {
    condition: (arg, { getState }) => {
      if (arg?.force) return true;
      const { marketDataLoaded, resetKubunFetching } =
        getState().currentsection;
      if (resetKubunFetching) return false;
      if (marketDataLoaded) return false;
      return true;
    }
  }
);

export const sectionSlice = createSlice({
  name: 'section',
  initialState: {
    section: '', //1 自社 2 競合
    kubun: 'direct',
    yearMonth: lastmonth, // 選択月
    yearMonth2: twoMonthsAgo,
    amazonCurrentLastMonth: '', // マーケットテーブルのデータがある最新の月
    rakutenCurrentLastMonth: '',
    amazonMonthList: [], // 期間選択リスト
    rakutenMonthList: [],
    amazonSelectedMonth: '', // チャネル別の最後に選択した月
    rakutenSelectedMonth: '',
    marketDataLoaded: false,
    resetKubunFetching: false
  },
  reducers: {
    registerMy: (state) => {
      state.section = 1;
    },
    registerOther: (state) => {
      state.section = 2;
    },
    changeKubun: (state, action) => {
      state.kubun = action.payload;
    },
    // resetKubunYearMonth: (state) => {
    //   return {
    //     ...state,
    //     kubun: 'direct',
    //     yearMonth: lastmonth
    //   };
    // },
    changeYearMonth: (state, action) => {
      state.yearMonth = action.payload;
    },
    /** プルダウン変更: 表示月とチャネル別記憶を同時更新 */
    setYearMonthForChannel: (state, action) => {
      const { channel, month } = action.payload;
      state.yearMonth = month;
      if (channel === 1) state.amazonSelectedMonth = month;
      else if (channel === 2) state.rakutenSelectedMonth = month;
    },
    /** 現在チャネルの月リストに yearMonth が無いときだけ補正 */
    ensureYearMonthForChannel: (state, action) => {
      const channel = action.payload;
      if (channel !== 1 && channel !== 2) return;

      const list = channel === 1 ? state.amazonMonthList : state.rakutenMonthList;
      if (!Array.isArray(list) || list.length === 0) return;
      if (list.includes(state.yearMonth)) return;

      const next = resolveYearMonthForChannel(channel, {
        amazonList: state.amazonMonthList,
        rakutenList: state.rakutenMonthList,
        amazonLast: state.amazonCurrentLastMonth,
        rakutenLast: state.rakutenCurrentLastMonth,
        amazonSelectedMonth: state.amazonSelectedMonth,
        rakutenSelectedMonth: state.rakutenSelectedMonth
      });

      if (next) {
        state.yearMonth = next;
        if (channel === 1) state.amazonSelectedMonth = next;
        else if (channel === 2) state.rakutenSelectedMonth = next;
      }
    },
    changeYearMonth2: (state, action) => {
      return {
        ...state,
        yearMonth2: action.payload
      };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetKubunYearMonth.fulfilled, (state, action) => {
      const {
        requestChannel,
        year_month,
        amazon_last_month,
        rakuten_last_month,
        amazon_month_list,
        rakuten_month_list
      } = action.payload;

      // 初回のみ: 各チャネルの最新月（amazon/rakuten_last_month）を選択月として記録
      let amazonSelectedMonth = state.amazonSelectedMonth;
      let rakutenSelectedMonth = state.rakutenSelectedMonth;
      let yearMonth = state.yearMonth;

      if (!state.marketDataLoaded) {
        if (amazon_last_month) amazonSelectedMonth = amazon_last_month;
        if (rakuten_last_month) rakutenSelectedMonth = rakuten_last_month;
        if (requestChannel === 1 && amazon_last_month) {
          yearMonth = amazon_last_month;
        } else if (requestChannel === 2 && rakuten_last_month) {
          yearMonth = rakuten_last_month;
        } else if (year_month) {
          yearMonth = year_month;
        }
      }

      return {
        ...state,
        kubun: 'direct',
        yearMonth,
        amazonCurrentLastMonth: amazon_last_month,
        rakutenCurrentLastMonth: rakuten_last_month,
        amazonMonthList: amazon_month_list,
        rakutenMonthList: rakuten_month_list,
        amazonSelectedMonth,
        rakutenSelectedMonth,
        marketDataLoaded: true,
        resetKubunFetching: false
      };
    });
    builder.addCase(resetKubunYearMonth.pending, (state) => {
      state.resetKubunFetching = true;
    });
    builder.addCase(resetKubunYearMonth.rejected, (state) => {
      state.resetKubunFetching = false;
    });
    builder.addCase(registerAmazon, (state) => {
      switchYearMonthOnChannelChange(state, 1);
    });
    builder.addCase(registerRakuten, (state) => {
      switchYearMonthOnChannelChange(state, 2);
    });
  }
});

export const {
  registerMy,
  registerOther,
  changeKubun,
  changeYearMonth,
  setYearMonthForChannel,
  ensureYearMonthForChannel,
  changeYearMonth2
} = sectionSlice.actions;

/** 月プルダウン変更時: 現在チャネルの選択月を記憶する */
export const selectYearMonth = (month) => (dispatch, getState) => {
  const channel = getState().currentchannel?.channel;
  if (channel === 1 || channel === 2) {
    dispatch(setYearMonthForChannel({ channel, month }));
  } else {
    dispatch(changeYearMonth(month));
  }
};
export const currentsection = (state) => state.currentsection.section;
export const currentkubun = (state) => state.currentsection.kubun;
export const currentmonth = (state) => state.currentsection.yearMonth;
export const comparemonth = (state) => state.currentsection.yearMonth2;
export const amazonCurrentlastmonth = (state) =>
  state.currentsection.amazonCurrentLastMonth;
export const rakutenCurrentlastmonth = (state) =>
  state.currentsection.rakutenCurrentLastMonth;
export const amazonMonthList = (state) => state.currentsection.amazonMonthList;
export const rakutenMonthList = (state) =>
  state.currentsection.rakutenMonthList;

export default sectionSlice.reducer;
